import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './AccountDetails.css'
import Button from '../Button/Button'
import Inputfield from '../Inputfield/Inputfield'

@CSSModules(styles, { allowMultiple: true })
export class AccountDetails extends Component {
  constructor(props) {
    super(props)
    this.state = { password: '', reference: '' }

    this._onPasswordInputChange = this._onPasswordInputChange.bind(this)
    this._onReferenceInputChange = this._onReferenceInputChange.bind(this)
    this._onCancelClick = this._onCancelClick.bind(this)
    this._onOkClick= this._onOkClick.bind(this)
    this._onKeyPress = this._onKeyPress.bind(this)
  }

  _onOkClick () {
    this.props.onOkClick()
  }

  _onCancelClick () {
    this.props.onCancelClick()
  }

  _onPasswordInputChange (event) {
    this.props.onAccountPasswordChange(event.target.value)
    this.setState({ password: event.target.value })
  }

  _onReferenceInputChange (event) {
    this.props.onAccountReferenceChange(event.target.value)
    this.setState({ reference: event.target.value })
  }

  _onKeyPress (event) {
    if (event.key === 'Enter' && !this._disableOk()) {
      this._onOkClick()
    }
  }

  _disableOk() {
    const { account } = this.props
    return this.state.password == '' || account.requiresReference && this.state.reference == ''
  }

  render () {
    const { account } = this.props
    let refPlaceholder = 'Bokningsreferens'

    if (account.requiresReference) {
      refPlaceholder = 'Bokningsreferens (Obligtoriskt)'
    }

    return (
      <div styleName="accountDetails">
        <div styleName="message">
          <p>Du har valt att boka med taxikonto: <strong>{`${account.number}`}</strong></p>
          <div styleName="account-inputs">
            <Inputfield
              autoFocus
              label="Lösenord"
              onChange={this._onPasswordInputChange}
              onKeyPress={this._onKeyPress}
              placeholder="Till ert konto"
              type="password" />
            <Inputfield
              label="Referens"
              onChange={this._onReferenceInputChange}
              onKeyPress={this._onKeyPress}
              placeholder={refPlaceholder} />
          </div>
          <div styleName="buttonContainer">
            <Button
              marginRight
              onClick={this._onCancelClick}
              secondary
              text="Avbryt" />
            <Button
              disabled={this._disableOk()}
              loading={this.props.validating}
              onClick={this._onOkClick}
              text="Ok" />                           
            </div>
        </div>
      </div>
    )
  }
}

AccountDetails.propTypes = {
  account: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  }),
  onAccountPasswordChange: PropTypes.func,
  onAccountReferenceChange: PropTypes.func,
  onCancelClick: PropTypes.func,
  onOkClick: PropTypes.func,
  validating: PropTypes.bool
}

export default AccountDetails



// WEBPACK FOOTER //
// ./src/components/AccountDetails/AccountDetails.js